<template>
    <div>
        <div class="main-container">
            <KidHeader :profileId="profileId" :serialNumber="serialNumber" />
            <div class="profile-section mb-2">
                <div class="pl-2">
                    <span>
                        <a class="text-black" href="javascript:void(0)" @click="$router.push({ path: '/kids-device', query:{ profileId: this.profileId }})"><i class="fas fa-long-arrow-alt-left"></i> <b>Home</b></a>
                    </span>
                </div>
            </div>
            <div class="profile-section pt-2">
                <div class="card p-4">
                    <h5 class="mb-3">Contact Information</h5>
                    <ul class="list-unstyled mb-0">
                        <li><strong>Email:</strong> <a href="mailto:support@padlock.se">support@padlock.se</a></li>
                        <li><strong>Phone:</strong> <a href="tel:+447349970810">+46 7037 92244</a></li>
                        <li><strong>Location:</strong> London, UK</li>
                        <li>
                            <strong>More details:</strong>
                            <a href="https://www.www.padlock.se" target="_blank" rel="noopener noreferrer">
                                https://www.www.padlock.se
                            </a>
                        </li>
                    </ul>

                    <!-- Subtle manage subscription link -->
                    <div class="mt-4 text-muted small">
                        Need to <a href="javascript:void(0)" @click="showCancelInfo = !showCancelInfo" class="text-muted">manage your subscription</a>? We're here to help.
                        
                        <!-- Hidden message that toggles on click -->
                        <div v-if="showCancelInfo" class="mt-2">
                            For any help related to your subscription, please contact us at 
                            <a href="mailto:support@padlock.se">support@padlock.se</a>.<br><br>
                            Our support team is available to assist you with cancellation requests, billing questions, or any concerns you may have.<br>
                            We're here to ensure your experience is smooth and transparent — don’t hesitate to reach out.
                        </div>

                    </div>
                </div>
            </div>

            <KidFooter :profileId="profileId" :serialNumber="serialNumber" />
        </div>
    </div>
</template>
<script>
import KidHeader from '@/components/KidHeader.vue'
import KidFooter from '@/components/KidFooter.vue'
import KidsService from "../../services/KidsService";

export default {
  name: 'Change Password',
  components: {
    KidHeader,
    KidFooter
  },
  data() {
    return {
        profileId: this.$route.query.profileId,
        isDisabled: false,
        showCancelInfo: false,
    }
  },
  methods: {
    
  },
  beforeMount() {
  },
}
</script>